import { Traditional } from "best-common-react";
import React from "react";
import { PulseLoader } from "react-spinners";

const InlineLoading = () => <PulseLoader size={12} color={Traditional["grey-three"]} loading={true} />;

export default InlineLoading;
